import { render, staticRenderFns } from "./AppButtonToggleReChallenge.vue?vue&type=template&id=2cfcf280&scoped=true"
import script from "./AppButtonToggleReChallenge.vue?vue&type=script&lang=ts"
export * from "./AppButtonToggleReChallenge.vue?vue&type=script&lang=ts"
import style0 from "./AppButtonToggleReChallenge.vue?vue&type=style&index=0&id=2cfcf280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfcf280",
  null
  
)

export default component.exports